import { render, staticRenderFns } from "./MonthlySSBPaye.vue?vue&type=template&id=58823f28"
import script from "./MonthlySSBPaye.vue?vue&type=script&lang=js"
export * from "./MonthlySSBPaye.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports